import React, { useEffect, useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getUserAllSubscriptions } from "../../../services/user.services";
import { SELECTED_TEAM } from "../../../redux/actions/teamActions";
import { useHistory } from "react-router-dom";
import mainImg from "../assets/dashboard.png";
import "./selectTeam.css";

const SelectTeam = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [teamData, setTeamData] = useState(null);
  const [loading, setLoading] = useState(false);

  const user = useSelector((state) => state.auth.user);
  const selectedTeam = useSelector((state) => state.team.selectedTeam);

  const navigateToCreateTeam = () => {
    history.push("/createteam");
  };

  const handleGetAllTeams = useCallback(async () => {
    if (!user) return;

    try {
      setLoading(true);
      const response = await getUserAllSubscriptions(
        { userId: user._id },
        user?.token
      );
      setTeamData(response.data);
    } catch (error) {
      console.error("Failed to fetch teams:", error);
    } finally {
      setLoading(false);
    }
  }, [user]);

  useEffect(() => {
    if (user) {
      handleGetAllTeams();
    }
  }, [user, handleGetAllTeams]);

  const handleSelectTeam = (i) => {
    console.log("Team selected:", teamData[i]); 
    dispatch({
      type: SELECTED_TEAM,
      payload: teamData[i],
    });
  };

  useEffect(() => {
    console.log("selectedTeam updated:", selectedTeam); 
    if (selectedTeam && selectedTeam.teamId) {
      console.log(
        "Navigating to dashboard with team name:",
        selectedTeam.teamId.teamName
      );
      history.push({
        pathname: "/",
        state: { teamName: selectedTeam.teamId.teamName },
      });
    }
  }, [selectedTeam, history]);
  const handleLogout = () => {
    history.push("/auth-navigator");
    dispatch({ type: "LOGOUT" });
  };

  return (
    <div className="mainBackground">
      {/* <h1 className="title">SELECT TEAM TO CONTINUE</h1> */}

      <div className="createBtnView" onClick={navigateToCreateTeam} >
        <div className="plus" >
          <p className="plusBtnCreateTeam">+</p>
        </div>
        <p className="addTeamTxt">ADD TEAM</p>
      </div>

      <div className="teamsButton">
        <div className="teamsMain">    
            {loading ? (
              <p style={{ color: "white" }}>Loading teams...</p>
            ) : (
              <div className="allTeams">
                {teamData &&
                  teamData.map(
                    (v, i) =>
                      v.teamId && (
                        <div
                          key={i}
                          className="teamContainer"
                          onClick={() => handleSelectTeam(i)}
                        >
                          <span className="allTeamName">
                            {v.teamId.teamName}{" "}
                          </span>
                          <span style={{ color: "white" }} className="arrow">
                            {"\u2192"}
                          </span>
                        </div>
                      )
                  )}
              </div>
            )}   
        </div>
      </div>
    </div>
  );
};

export default SelectTeam;
